export const replaceAccents = (str: string) => {
    if (!str) return str;

    return str
        .toLowerCase()
        .replace(/[áàãâäą]/gi, 'a')
        .replace(/[éèëêę]/gi, 'e')
        .replace(/[íìïî]/gi, 'i')
        .replace(/[óòöôõø]/gi, 'o')
        .replace(/[úùüû]/gi, 'u')
        .replace(/[çć]/gi, 'c')
        .replace(/[ñń]/gi, 'n')
        .replace(/[ł]/gi, 'l')
        .replace(/[żź]/gi, 'z');
};
